import type { Dispatch } from '@reduxjs/toolkit';

/**
 * Dispatches an RTK Query util action (e.g. `<api>.util.updateQueryData(...)`
 * or `<api>.util.invalidateTags(...)`) from a context that doesn't carry
 * the per-slice RootState type. RTK Query's util actions are typed against
 * each individual createApi slice's RootState shape — when dispatched from
 * a generic middleware or a `dispatch: (a: unknown) => unknown` callback,
 * TypeScript's contravariant function-arg check fires.
 * This helper is the project's single approved place to perform that
 * type-erasure. Runtime is identical to a normal dispatch.
 * Two arities so the same helper works for:
 * - Redux middleware: `dispatchCacheAction(api.dispatch, action)`
 * - RTK Query `onQueryStarted` callbacks: `dispatchCacheAction(dispatch, action)`
 */
export function dispatchCacheAction(
  dispatch: Dispatch | ((action: unknown) => unknown),
  action: unknown,
): void {
  (dispatch as (a: unknown) => unknown)(action);
}
